<template>
    <div>
        <Titulo titulo="HISTORIAL DE CONSUMOS DE AGUA"/>
    </div>
</template>

<script>
import Titulo from '@/components/Titulo.vue'

export default {
    name: 'ConsumoAgua',
    props: {
    },
    components: {
        Titulo
    },
    data() {
        return {
            variable: ''
        }
    },
    created() {
    }
}
</script>

<style scoped>

</style>